/**
 * PSIFY IMMERSIVE — Cursor custom (dot + glow difuz)
 * Doar pe pointer fin. GSAP quickTo pentru mișcare fluidă.
 */
import { gsap } from 'gsap'

export function initCursor() {
  if (!window.matchMedia('(pointer: fine)').matches) return

  const page = document.querySelector('.psi-page')
  if (!page) return

  const dot = document.createElement('div')
  dot.className = 'psi-cursor-dot'
  const glow = document.createElement('div')
  glow.className = 'psi-cursor-glow'
  document.body.append(glow, dot)

  page.classList.add('has-custom-cursor')

  const dotX = gsap.quickTo(dot, 'x', { duration: 0.12, ease: 'power3.out' })
  const dotY = gsap.quickTo(dot, 'y', { duration: 0.12, ease: 'power3.out' })
  const glowX = gsap.quickTo(glow, 'x', { duration: 0.55, ease: 'power3.out' })
  const glowY = gsap.quickTo(glow, 'y', { duration: 0.55, ease: 'power3.out' })

  window.addEventListener('mousemove', (e) => {
    dotX(e.clientX)
    dotY(e.clientY)
    glowX(e.clientX)
    glowY(e.clientY)
  }, { passive: true })

  // dilatare calmă pe elemente interactive
  const interactive = 'a, button, [role="button"], input, textarea, select, .psi-doctor-tile, .psi-service-card'
  document.addEventListener('mouseover', (e) => {
    if (e.target.closest(interactive)) page.classList.add('is-cursor-hover')
  }, { passive: true })
  document.addEventListener('mouseout', (e) => {
    if (e.target.closest(interactive)) page.classList.remove('is-cursor-hover')
  }, { passive: true })
}
